import React from 'react'
import PropTypes from 'prop-types';
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom';
import Helmet from "react-helmet";
import {HeaderView} from '../HeaderView/HeaderView'
import {FooterLinks} from '../FooterLinks/FooterLinks'
import {SocialView} from '../SocialView/SocialView'
import {FooterNote} from '../FooterLinks/FooterNote'
import {SearchView} from '../SearchView/SearchView'
import {fetchMenusIfNeeded, selectCustomPage,
        fetchCustomPageIfNeeded, CLIENT_BASE_URL} from '../../actions'

export class Template1 extends React.Component {

  constructor (props) {
    super(props)
    this.gotoPage = this.gotoPage.bind(this)
  }

  drawBackgroundImage (poster) {
    poster = CLIENT_BASE_URL + poster
    return {
      backgroundImage: `url('${poster}')`
    }
  }

  componentWillMount (p) {
    const {match, dispatch} = this.props

    if (match.params && Object.keys(match.params).length) {
      dispatch(selectCustomPage(match.params[0]))
      dispatch(fetchCustomPageIfNeeded(match.params[0]))
    } else {
      dispatch(selectCustomPage(''))
    }
  }

  componentDidMount () {

    const {dispatch, match} = this.props

    if (match.params && Object.keys(match.params).length) {
      dispatch(fetchMenusIfNeeded(this.props.selectedScope))
      dispatch(selectCustomPage(match.params[0]))
    }

  }

  componentWillReceiveProps (nextProps) {
    const {match, dispatch} = nextProps
    if (match !== this.props.match) {
      dispatch(fetchMenusIfNeeded(nextProps.selectedScope))
    }

    if (this.props.match.params !== match.params) {
      dispatch(selectCustomPage(match.params[0]))
      dispatch(fetchCustomPageIfNeeded(match.params[0]))
    }
  }

  componentWillUnmount () {
    const {dispatch} = this.props
    dispatch(selectCustomPage(''))
  }

  gotoPage (page) {
    this.props.history.push('/pesquisa')
  }

  render () {
    const {menus, dispatch} = this.props
    const bottom_menus = menus.bottom || []
    const top_menus = menus.top || []
    const {details} = this.props
    if (!Object.keys(details).length) {
      return (
        <div></div>
        )
    }

    let mainHtmlClassName = ''
    if (parseInt(details['0'].num_text_cols, 10) === 2) {
      mainHtmlClassName = 'twocols'
    }

    // <div className='thumb' style={this.drawBackgroundImage(details['0'].poster)}></div>
    const topLargeImg = CLIENT_BASE_URL + details['0'].poster

    let desc = '';

    if (typeof details !== "undefined" && details.length) {
      desc = details['0'].mainhtml
        .replace(/<(?:.|\n)*?>/gm, "")
        .replace(/&nbsp;|\n|\r/gm, " ");
    }

    return (
      <div>
        <Helmet
          title={details['0'].title}
          meta={[
            { name: "description", content: desc },
            {
              property: "og:image",
              content: topLargeImg
            },
            { property: "og:title", content: details['0'].title },
            { property: "og:type", content: "article" },
            {
              property: "og:url",
              content:
                CLIENT_BASE_URL + "/t1/" + this.props.match.params[0]
            }
          ]}
        />
        <HeaderView top_menus={top_menus} dispatch={dispatch}/>
        <div id='presentation-view' className='row team-view'>
          <div className='col-md-12 no-pad text-left' style={{position: 'relative'}}>
            <p className='left-tag'>{details['0'].title}</p>
            <SearchView gotoPage={this.gotoPage} dispatch={dispatch} customStyle={'alignright'} />
          </div>
          <div className='row main-block'>
            <div className='col-sm-4 col-md-4 col-lg-3  side-block no-pad'>
              <img className='thumb' src={topLargeImg} />
            </div>
            <div className='col-sm-8 col-md-offset-1 col-md-6 col-lg-5'>
              <div className='txt-block'>
                <p className={mainHtmlClassName} dangerouslySetInnerHTML={{ __html: details['0'].mainhtml }}></p>
              </div>
            </div>
          </div>
        </div>

        <FooterLinks bottom_menus={bottom_menus}/>
        <SocialView customclass='lite'/>
        <FooterNote />
      </div>
    )
  }
}

Template1.propTypes = {
  dispatch: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  menus: PropTypes.any.isRequired,
  details: PropTypes.object.isRequired,
  selectedCustomPage: PropTypes.string.isRequired,
  selectedScope: PropTypes.string.isRequired,
  history: PropTypes.object.isRequired
}

function mapStateToProps (state) {
  const {getMenus, selectedCustomPage, getCustomPage, selectedScope} = state

  const {
    isFetchingMenus,
    lastUpdatedMenus,
    items: menus
  } = getMenus[selectedScope] || {
    isFetchingMenus: true,
    items: []
  }

  const {
    isFetchingCPage,
    items: details
  } = getCustomPage[selectedCustomPage] || {
    isFetchingCPage: true,
    items: {}
  }

  return {
    isFetchingMenus,
    lastUpdatedMenus,
    menus,
    isFetchingCPage,
    details,
    selectedCustomPage,
    selectedScope
  }
}



export default withRouter(connect(
  mapStateToProps
)(Template1));



// WEBPACK FOOTER //
// ./src/views/AboutView/Template1.js